<template>
  <div class="filter-schedule">
    <InputFilter
      :value="searchScheduleStr || ''"
      :placeholder="$t('common.shedule')"
      :clear-input="clearInput"
      :default-store-value="{}"
      :is-readonly-now="show"
      action-name="search/SET_SCHEDULE"
      @clicked="show = true"
    />
    <el-dialog
      class="schedule-modal filter-modal-wrapper"
      :visible.sync="show"
      width="300px"
      :modal-append-to-body="true"
      :append-to-body="true"
      :center="true"
      :lock-scroll="true"
      :show-close="false"
    >
      <ModalSchedule @clicked="chooseSchedule" />
    </el-dialog>
  </div>
</template>

<script>
import InputFilter from '~/components/Common/InputFilter'
import ModalSchedule from '~/components/Search/Modals/Schedule'
import ScheduleParserMixin from '~/dependencies/mixins/schedule-parser'

export default {
  name: 'Schedule',
  components: {
    ModalSchedule,
    InputFilter
  },
  mixins: [ScheduleParserMixin],
  data() {
    return {
      show: false
    }
  },
  methods: {
    chooseSchedule() {
      this.show = false
    },
    clearInput() {
      this.setSchedule(null)
    }
  }
}
</script>

<style scoped>
.schedule-modal {
  margin-top: calc(40vh - 200px) !important;
}
</style>
